import {
  addMember,
  fetchMembers,
  updateMember,
  deleteMember,
} from "@/api/memberService";

export default {
  //Add group member
  async addMember({ commit, rootState, dispatch, state }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.addMemberBtn.load = true;
      rootState.loading.addMemberBtn.disabled = true;
      await addMember(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Member added!",
          color: "success",
        },
        { root: true }
      );
      const pageNumber = state.members.currentPage;
      dispatch("fetchMembers", { id: payload.id, pageNumber });
      rootState.loading.addMemberBtn.load = false;
      rootState.loading.addMemberBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.addMemberBtn.load = false;
      rootState.loading.addMemberBtn.disabled = false;
    }
  },

  //Fetch members
  async fetchMembers({ commit }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchMembers(payload);
      const members = response.data.data;
      commit("SET_MEMBER_DATA", members);
      commit("SET_MEMBER_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your members arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Update member
  async updateMember({ commit, rootState, dispatch, state }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.updateMemberBtn.load = true;
      rootState.loading.updateMemberBtn.disabled = true;
      await updateMember(payload);
      const pageNumber = state.members.currentPage;
      dispatch("fetchMembers", { id: payload.groupId, pageNumber });
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Member updated!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.updateMemberBtn.load = false;
      rootState.loading.updateMemberBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.updateMemberBtn.load = false;
      rootState.loading.updateMemberBtn.disabled = false;
    }
  },

  //Delete member
  async deleteMember(context, payload) {
    context.commit("SHOW_PROGRESSBAR", true, { root: true });
    await deleteMember(payload.memberId);
    const pageNumber = context.state.members.currentPage;
    context.dispatch("fetchMembers", { id: payload.groupId, pageNumber });
    context.commit("HIDE_PROGRESSBAR", false, { root: true });
    context.commit(
      "SHOW_SNACKBAR",
      {
        text: "Member deleted!",
        color: "success",
      },
      { root: true }
    );
  },
};
